import styled from "styled-components";
import { Tabs } from "react-tabs";

export const Container = styled(Tabs)``;
